import React from 'react'
import './myprofileportfolio.css';
import android from '../../../assets/android.webp';
import { useEffect } from 'react';

const MyProfilePortfolio = ({ portfolioTitlesArray, portfoliohyperlinksArray, portfolioIDArray, handlePortfolioDelete, PortfolioImageLinksArray}) => {

    useEffect(() => {
    }, []);

    return (
        <div className='myportBars'>
            {portfoliohyperlinksArray != [''] > 0 ? (
                portfolioTitlesArray.map((title, index) => (
                    <div key={index} className='myportBar'>
                        <a href={`https://${portfoliohyperlinksArray[index]}`} target="_blank" rel="noopener noreferrer">
                            <img src={PortfolioImageLinksArray[index]} alt="" className='myportImg' />
                        </a>
                        <div className='myportText'>
                            <span style={{ marginLeft: '0.6rem' }}>{title}</span>
                            <button className='portdelbtn' onClick={() => handlePortfolioDelete(portfolioIDArray[index])}>
                                <i class="fa-solid fa-trash"></i>
                            </button>
                        </div>
                    </div>
                ))
            ) : (
                <div className="no-portfolio">
                    No Portfolio Added
                </div>
            )}
        </div>
    )
}

export default MyProfilePortfolio